import { render, staticRenderFns } from "./AppCollapseItem.vue?vue&type=template&id=6e44095c&"
import script from "./AppCollapseItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports